<template>

    <div v-if="isTop.isTisikiTop" class="content">
        知識力 : 物事について深く知ろうとする能力
    </div>
    <div v-if="isTop.isGinouTop" class="content">
        技能力 : 自らが仕事や業務をやり遂げるための能力
    </div>
    <div v-if="isTop.isSikouTop" class="content">
        思考力 : 頭を使って考え処理する能力
    </div>
    <div v-if="isTop.isTaizinTop" class="content">
        対人力 : 対人関係において発揮される能力
    </div>
    <div v-if="isTop.isManagementTop" class="content">
        マネジメント力 : 人やチームを動かし、他力を活かす能力
    </div>

</template>
<style lang="scss" scoped>
.content {
    justify-content: left;
    margin-top: -23px;
    margin-bottom: -7px;
    margin-left: 20px;
    padding-top: 24px;
    font-size: 15px;
}
</style>
<script lang="ts">
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export default class TechnicalSkill extends Vue {
  @Prop({ type: Object, required: true }) isTop!: { isTisikiTop: boolean; isGinouTop: boolean; isSikouTop: boolean; isTaizinTop: boolean; isManagementTop: boolean };
}
</script>
